import { PaperReferralApprovalResult } from '@dreryk/egabinet-referral-frontend-api';
import { VisitReferralToRehabilitationApproveCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';
import { ActionBar, ButtonVariant } from '@dreryk/react-components';
import { useDraftRemoveByTokenCqrsCommand } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../../referral.draft';
import { useReferralPrintCommandSuccessHandler } from '../../shared/useReferralPrintCommandSuccessHandler';
import { referralTranslationKeys } from '../../translations';
import {
   ReferralToRehabilitationFormBean,
   ReferralToRehabilitationFormController,
} from '../ReferralToRehabilitationForm/ReferralToRehabilitationForm.types';

import { mapReferralToRehabilitationFormBeanToCommandReferralDetails } from './ReferralToRehabilitationSendAction.utils';

type ReferralToRehabilitationSendActionProps = {
   readonly handleSubmit: ReferralToRehabilitationFormController['handleSubmit'];
   readonly visitId: number;
   readonly onSuccess: PromiseVoidFunction | VoidFunction;
};

export const ReferralToRehabilitationSendAction = (props: ReferralToRehabilitationSendActionProps): JSX.Element => {
   const handlePrintSuccess = useReferralPrintCommandSuccessHandler({
      visitId: props.visitId,
      onPrintDone: props.onSuccess,
   });

   const { executeAsync: removeDraft } = useDraftRemoveByTokenCqrsCommand();

   const { executeAsync: sendReferralToRehabilitation } = useCqrsCommand<
      PaperReferralApprovalResult,
      ReferralToRehabilitationFormBean
   >(
      (parameters) => {
         const command = new VisitReferralToRehabilitationApproveCommand();
         command.visitId = props.visitId;
         command.referralDetails = mapReferralToRehabilitationFormBeanToCommandReferralDetails(parameters);
         return command;
      },
      {
         onSuccess: async (result) => {
            handlePrintSuccess(result);
            await removeDraft({ token: getReferralDraftToken('referralToRehabilitation', props.visitId) });
         },
      }
   );
   return (
      <ActionBar.PrimaryButton
         variant={ButtonVariant.PRIMARY}
         onClick={props.handleSubmit(sendReferralToRehabilitation)}
         label={referralTranslationKeys.actionBar.confirmAndPrint}
         testId={'confirmAndPrint'}
         blockingOperation
      />
   );
};
